<footer class="layout">
  <section class="container-top">
    <div class="item-logo">
      <img [src]="dataSignal()?.logo" [alt]="dataSignal()?.name" [title]="dataSignal()?.name" loading="lazy" />
    </div>
    <div class="container-menu">
      @for (menu of dataSignal()?.menu; track i; let i = $index) {
      <dl class="{{ menu.item === 1 ? 'container-item-1' : 'container-item-2' }}">
        <dt class="item-header font-size-18 font-weight-semibold cursor-default">{{ menu.header }}</dt>
        <div class="{{ menu.item === 1 ? 'container-sub-item-1' : 'container-sub-item-2' }}">
          @for (item of menu.menu; track i; let i = $index; let last = $last) {
          <dd
            class="font-size-16 font-weight-medium cursor-pointer {{ i < footerlengthSignal() ? 'item-1' : 'item-2' }}"
            (click)="onClick(item)"
            (keyup.enter)="onClick(item)"
            tabindex="0"
          >
            <!-- menu.item === 1 && last ? 'item-position' : -->
            {{ item.label }}
          </dd>
          }
        </div>
      </dl>
      }
    </div>
  </section>
  <section class="follow-us-top">
    <p class="font-size-16 font-weight-medium cursor-default">Follow us :</p>
    <div class="container-item-follow-us">
      @for (followUs of dataSignal()?.copyRight?.followUs; track i; let i = $index;) {
      <div class="item-follow-us" (click)="onClick(followUs)" (keyup.enter)="onClick(followUs)" tabindex="0">
        <a [href]="followUs.url" target="_blank" rel="">
          <img [src]="followUs.icon" alt="ไอคอนสำหรับโซเชียลมีเดียต่างๆ " title="ไอคอนสำหรับโซเชียลมีเดียต่างๆ" loading="lazy" />
        </a>
      </div>
      }
    </div>
  </section>

  <div class="item-line"></div>

  <section class="container-bottom">
    <div class="container-copy-right">
      <!-- <p class="font-size-14 font-weight-medium mr-copy-right cursor-default">
        Copyright &#169; 2024 {{ dataSignal()?.name }} สงวนสิทธิ์ทุกประการ
      </p> -->
      <p class="font-size-16 font-weight-medium mr-copy-right cursor-default">
        Copyright
        <span class="copyright-symbol">&#169;</span>
        2024 {{ dataSignal()?.name }} สงวนสิทธิ์ทุกประการ
      </p>

      <div class="container-item-copy-right">
        @for (menu of dataSignal()?.copyRight?.menu; track i ; let i = $index; let first = $first; let last = $last) {
        <p class="font-size-16 font-weight-medium {{ first || last ? 'item-line-copy-right' : '' }} cursor-default">|</p>
        <p class="font-size-16 font-weight-medium cursor-pointer" (click)="onClick(menu)" (keyup.enter)="onClick(menu)" tabindex="0">
          {{ menu.label }}
        </p>
        }
      </div>
    </div>
    <div class="follow-us-bottom">
      <p class="font-size-16 font-weight-medium cursor-default">Follow us :</p>
      <div class="container-item-follow-us">
        @for (followUs of dataSignal()?.copyRight?.followUs; track i ; let i = $index;) {
        <div class="item-follow-us cursor-pointer" (click)="onClick(followUs)" (keyup.enter)="onClick(followUs)" tabindex="0">
          <a [href]="followUs.url" target="_blank" rel="">
            <img [src]="followUs.icon" alt="ไอคอนสำหรับโซเชียลมีเดียต่างๆ " title="ไอคอนสำหรับโซเชียลมีเดียต่างๆ" loading="lazy" />
          </a>
        </div>
        }
      </div>
    </div>
  </section>
</footer>
